import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { FormControl, InputLabel } from "@mui/material";
import Box from "components/common/Box";
import TextField from "components/common/TextField";
import Stack from "components/common/Stack";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#1A1A1A",
    padding: "5px 2px",
  },
  no_button: {
    marginRight: "7rem",
    width: "100.17px",
    height: "40px",
    marginBottom: "1.2rem",
    cursor: "pointer",
    position: "relative",
    left: "50px",
  },
  yes_button: {
    background: "red",
    marginRight: "2rem",
    width: "100.17px",
    height: "40px",
    marginBottom: "1.2rem",
    cursor: "pointer",
    position: "relative",
    right: "50px",
  },
  edit_heading: {
    display: "flex",
    justifyContent: "space-between",
  },
  diolog_heading: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#1A1A1A",
    padding: "18px 2px",
  },
  close_icon: {
    cursor: "pointer",
    position: "relative",
    top: "10px",
  },
  connetor_image: {
    width: "300px",
    height: "25px",
    border: "1px solid rgba(0, 0, 0, 0.27)",
    padding: "10px 10px",
    borderRadius: "5px",
  },
}));
export default function EditDeleteConnectorModel({
  open,
  closeDeleteConnector,
  connectortypeopen,
  handleDeleteConnector,
  editdata,
  handleSubmitEditConnectot,
}) {
  const classes = useStyles();
  const [formData, setFormData] = React.useState({
    ac_connector_name: "",
    dc_connector_name: "",
    acConnectorFile: null,
    dcConnectorFile: null,
  });
  
  const handleEditClose =()=>{
    closeDeleteConnector()
  }
  
  const [preview, setPreview] = React.useState(null);
  const fileInputRef = React.useRef(null);
  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleDeleteconnector = (id) => {
    handleDeleteConnector(id);
  };

  const handleChange = (prop) => (event) => {    
    setFormData({ ...formData, [prop]: event.target.value });
  };

  const handleFileChange = (name, event) => {
    const file = event.currentTarget.files[0];
    setFormData({ ...formData, [name]: file });

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdate = (id) => {
    const bodyFormData = new FormData();
    
    Object.keys(formData).forEach((val) => {
      
      bodyFormData.append(val, formData[val]);
    });
    handleSubmitEditConnectot(bodyFormData, id);
   
    closeDeleteConnector();
  };

  React.useEffect(() => {
    if (editdata.type === "AC") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        dc_connector_name: "",
        ac_connector_name: editdata.name || "",
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        dc_connector_name: editdata.name || "",
        ac_connector_name:"",
      }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editdata]);

  return (
    <>
      {connectortypeopen === "deleteconnectortype" && (
        <Dialog
          open={open}
          onClose={closeDeleteConnector}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <DialogTitle className={classes.heading}>
              Are you sure you want to delete this connector?
            </DialogTitle>
          </DialogContent>
          <DialogActions>
            <Box>
              <Button
                className={classes.no_button}
                variant="outlined"
                onClick={closeDeleteConnector}
              >
                No
              </Button>
              <Button
                className={classes.yes_button}
                variant="contained"
                sx={{}}
                onClick={() => handleDeleteconnector(editdata.id)}
              >
                Yes
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
      {connectortypeopen === "editconnector" && (
        <Dialog
          open={open}
          onClose={handleEditClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <div className={classes.edit_heading}>
              <DialogTitle className={classes.diolog_heading}>
                Edit {editdata.type} Connector
              </DialogTitle>
              <CloseIcon
                className={classes.close_icon}
                onClick={handleEditClose}
              />
            </div>
            <div>
              <Box>
                <InputLabel>Add Connector name</InputLabel>
                <FormControl fullWidth sx={{ marginBottom: "0px" }}>
                  <TextField
                    fullWidth
                    size="small"
                    value={
                      editdata.type === "AC"
                        ? formData.ac_connector_name
                        : formData.dc_connector_name
                    }
                    onChange={handleChange(
                      editdata.type === "AC"
                        ? "ac_connector_name"
                        : "dc_connector_name"
                    )}
                    sx={{ marginBottom: "20px" }}
                    onInput={(e) => {
                      const value = e.target.value.replace(
                        /(\..*?)\..*/g,
                        "$1"
                      );
                      e.target.value = value;
                    }}
                  />
                </FormControl>
              </Box>
              <InputLabel>Add Connector Image</InputLabel>
              <Stack xs={6}>
                <Box sx={{ marginTop: "10px", marginBottom: "20px" }}>
                  <Box className={classes.connetor_image}>
                    {preview ? (
                      <div>
                        <img
                          src={preview}
                          alt="Selected Thumbnail"
                          style={{ width: "70px", height: "40px" }}
                          onClick={handleImageClick}
                        />
                      </div>
                    ) : editdata?.thumbnail ? (
                      <img
                        src={editdata.thumbnail}
                        alt="Selected Thumbnail"
                        style={{
                          width: "70px",
                          height: "45px",
                          marginTop: "-10px",
                        }}
                        onClick={handleImageClick}
                      />
                    ) : (
                      <p
                        onClick={handleImageClick}
                        style={{
                          marginTop: "-5px",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                      >
                        no data
                      </p>
                    )}

                    <input
                      hidden
                      ref={fileInputRef}
                      id="file"
                      name="photo"
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={(event) => {
                        handleFileChange(
                          editdata.type === "AC"
                            ? "acConnectorFile"
                            : "dcConnectorFile",
                          event
                        );
                      }}
                    />
                  </Box>
                </Box>
              </Stack>
              <Button
                variant="contained"
                onClick={() => handleUpdate(editdata.id)}
                disabled={
                  editdata.type === "AC"
                    ? !formData.ac_connector_name
                    : !formData.dc_connector_name
                }
              >
                Update
              </Button>
            </div>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      )}
    </>
  );
}
